<template>
  <div class="layout">

    <Animate ref="animate" />

    <el-row class="survey">
      <el-col>
        <p class="title">科研概况 /Scientific Research Overview</p>
        <p class="content">{{$t('layoutDetails.面向生物大分子、生物信息处理、药物分子构建模拟与设计工程开发平台。')}}</p>
      </el-col>
    </el-row>

    <el-row class="main">
      <el-col><p class="title">科研方向 /Main Research Areas</p></el-col>
      <el-col>
        <el-link :underline="false" @click.native="open1">1.{{$t('layoutDetails.计算机辅助药物和蛋白质设计')}}</el-link>
      </el-col>
      <el-col>
        <el-link :underline="false" @click.native="open2">2.{{$t('layoutDetails.基于分子模拟的蛋白质相互作用研究')}}</el-link>
      </el-col>
      <el-col>
        <el-link :underline="false" @click.native="open3">3.{{$t('layoutDetails.以药物分子为重点的生物大分子的三维结构及修饰的计算与模拟研究')}}</el-link>
      </el-col>
      <el-col>
        <el-link :underline="false" @click.native="open4">4.{{$t('layoutDetails.生物大分子数据库及信息处理研究')}}</el-link>
      </el-col>
      <el-col>
        <el-link :underline="false" @click.native="open5">5.{{$t('layoutDetails.以现代生物技术为研究手段开展的药物靶点的发现和分子机制的研究')}}</el-link>
      </el-col>
      <el-col>
        <el-link :underline="false" @click.native="open6">6.{{$t('layoutDetails.药物分子的生物验证和天然产物研究')}}</el-link>
      </el-col>
      <el-col>
        <el-link :underline="false" @click.native="open7">7.{{$t('layoutDetails.人或动物重大疾病的发病机理及防治研究')}}</el-link>
      </el-col>
      <el-col>
        <el-link :underline="false" @click.native="open8">8.{{$t('layoutDetails.重要生物酶的开发研究')}}</el-link>
      </el-col>
    </el-row>

    <layout-detail :title="$t('layoutDetails.' + titles[index])" :content="$t('layoutContents.' + contents[index])" ref="detail"/>

  </div>
</template>

<script>
  import { ElMessageBox } from 'element-plus'

  import LayoutDetail from "../childComps/LayoutDetail";
  import Animate from "@/components/common/Animate";

  import {ref, reactive, getCurrentInstance, onMounted} from 'vue'

  export default {
    name: "Layout",
    components: {
      LayoutDetail,
      Animate,
    },
    setup(){

      let instance = ref(null);
      instance = getCurrentInstance();
      // index
      let index = ref(0);
      // 标题
      let titles = reactive(['计算机辅助药物和蛋白质设计','基于分子模拟的蛋白质相互作用研究','以药物分子为重点的生物大分子的三维结构及修饰的计算与模拟研究',
        '生物大分子数据库及信息处理研究','以现代生物技术为研究手段开展的药物靶点的发现和分子机制的研究','药物分子的生物验证和天然产物研究',
        '人或动物重大疾病的发病机理及防治研究','重要生物酶的开发研究'
      ]);
      // 内容
      let contents = reactive(['计算机辅助药物和蛋白质设计','基于分子模拟的蛋白质相互作用研究','以药物分子为重点的生物大分子的三维结构及修饰的计算与模拟研究',
        '生物大分子数据库及信息处理研究','以现代生物技术为研究手段开展的药物靶点的发现和分子机制的研究','药物分子的生物验证和天然产物研究',
        '人或动物重大疾病的发病机理及防治研究','重要生物酶的开发研究'
      ])

      onMounted(() => {
        let timer = setTimeout(function () {
          instance.proxy.$refs.animate.isShow = false
          clearTimeout(timer)
        }, 100)
      })


      // methods
      function open1() {
        index.value = 0
        instance.proxy.$refs.detail.dialogVisible = true;
      }
      function open2() {
        index.value = 1
        instance.proxy.$refs.detail.dialogVisible = true;
      }
      function open3() {
        index.value = 2
        instance.proxy.$refs.detail.dialogVisible = true;
      }
      function open4() {
        index.value = 3
        instance.proxy.$refs.detail.dialogVisible = true;
      }
      function open5() {
        index.value = 4
        instance.proxy.$refs.detail.dialogVisible = true;
      }
      function open6() {
        index.value = 5
        instance.proxy.$refs.detail.dialogVisible = true;
      }
      function open7() {
        index.value = 6
        instance.proxy.$refs.detail.dialogVisible = true;
      }
      function open8() {
        index.value = 7
        instance.proxy.$refs.detail.dialogVisible = true;
      }


      return{ titles, contents, index,
        open1, open2, open3, open4, open5, open6, open7, open8 }
    },
  }
</script>

<style scoped lang="less">

  .layout{
    padding: 50px 14% 85px 14%;

    .survey{
      color: #888;
      font-size: 14px;
      .title{
        font-size: 18px;
      }
      .content{
        font-size: 16px;
        margin-left: 25px;
        padding: 30px 0 50px;
      }
    }

    .main{
      color: #888;
      font-size: 14px;
      line-height: 30px;
      .title{
        font-size: 18px;
        padding-bottom: 30px;
      }
      .el-link{
        margin-left: 25px;
        font-size: 16px;
        line-height: 40px;
      }
    }

  }

</style>